import React from "react";
import { SpheraConfirmation } from "@sphera-cloud/component-ui-reactjs";

export const ConfirmDeleteTokenDialog = (props) => {
	return (
		<SpheraConfirmation
			hasAction
			isDangerConfirm
			actionText={props.localizations.Delete}
			cancelText={props.localizations.Cancel}
			onCancel={props.toggleConfirmDeleteDialog}
			onClose={props.toggleConfirmDeleteDialog}  
			title={props.localizations.DeleteTokenName + props.card?.apiToken?.name}
			onAction={() => props.deleteToken(props.card)}
		>
			{props.localizations.DeleteTokenWarning}
			<br></br>
			<br></br>
			{props.localizations.DeleteToken}
		</SpheraConfirmation>
	);
};
